// extracted by mini-css-extract-plugin
module.exports = {"card":"_2Uf7o"};